export default __webpack_public_path__ + "static/media/announcement-grey.1be99298.svg";